export default __webpack_public_path__ + "static/media/milholland-bg.31cbebe5.webp";